import { Link } from 'react-router-dom'

import { Entete, IconeChevron } from '../composants'

const SECTIONS: { titre: string; liens: { to: string; libelle: string; detail: string }[] }[] = [
  {
    titre: 'Suivi',
    liens: [
      { to: '/recurrences', libelle: 'Récurrences', detail: 'Échéancier, primes, loyer, salaire' },
      { to: '/remboursements', libelle: 'À recevoir', detail: 'Remboursements et parts refacturées' },
      { to: '/justificatif', libelle: 'Justificatif', detail: 'Décompte PDF à remettre' },
      { to: '/budgets', libelle: 'Enveloppes', detail: 'Budgets par catégorie' },
    ],
  },
  {
    titre: 'Paramétrage',
    liens: [
      { to: '/comptes', libelle: 'Comptes', detail: 'Soldes de départ, archivage' },
      { to: '/categories', libelle: 'Catégories', detail: 'Et répartition proposée par défaut' },
      { to: '/tiers', libelle: 'Tiers', detail: 'Assurances et personnes' },
      { to: '/modeles', libelle: 'Modèles de répartition', detail: 'Cascades réutilisables' },
    ],
  },
  {
    titre: 'Application',
    liens: [
      { to: '/reglages', libelle: 'Réglages', detail: 'Coordonnées, prévisions, sauvegarde' },
      { to: '/installation', libelle: 'Installation', detail: 'Sur l’écran d’accueil de l’iPhone' },
    ],
  },
]

export function PagePlus() {
  return (
    <>
      <Entete titre="Plus" />
      <main className="contenu">
        {SECTIONS.map((s) => (
          <section key={s.titre} className="pile pile--serree">
            <h3 className="groupe-date">{s.titre}</h3>
            <ul className="menu">
              {s.liens.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="item">
                    <div className="grandir">
                      <div className="item__principal">{l.libelle}</div>
                      <div className="item__secondaire">{l.detail}</div>
                    </div>
                    <span className="chevron"><IconeChevron /></span>
                  </Link>
                </li>
              ))}
            </ul>
          </section>
        ))}
      </main>
    </>
  )
}
